import React from 'react';
import { AlertTriangle } from 'lucide-react';
import logger from '../utils/logger';

// Top-level error boundary — keeps a render error from blanking the whole app.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    logger.error('Unhandled UI error:', error, info?.componentStack);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '70vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 'var(--spacing-xl)'
        }}>
          <div style={{
            textAlign: 'center',
            maxWidth: '420px',
            background: 'var(--bg-primary)',
            border: '1px solid var(--border-color)',
            borderRadius: 'var(--radius-lg)',
            padding: 'var(--spacing-xl)',
            boxShadow: 'var(--shadow-md)'
          }}>
            <div style={{
              width: 56, height: 56, borderRadius: '50%',
              background: 'rgba(224,88,78,.12)', color: 'var(--color-danger)',
              display: 'grid', placeItems: 'center', margin: '0 auto var(--spacing-lg)'
            }}>
              <AlertTriangle size={28} />
            </div>
            <h2 style={{ color: 'var(--text-primary)', margin: '0 0 var(--spacing-sm)' }}>
              Се појави грешка
            </h2>
            <p style={{ color: 'var(--text-secondary)', margin: '0 0 var(--spacing-lg)', fontSize: '0.95rem' }}>
              Нешто тргна наопаку при прикажувањето на оваа страница. Ве молиме обидете се повторно.
            </p>
            <button className="btn btn-primary" onClick={this.handleReload}>
              Превчитај ја страницата
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
